import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20modern%20entertainment%20media%20collage%20with%20film%20reels%20vinyl%20records%20concert%20lights%20and%20cultural%20elements%2C%20artistic%20dark%20background%20with%20warm%20golden%20and%20amber%20accents%2C%20sophisticated%20cinematic%20composition%2C%20rich%20texture%20with%20soft%20glow%20effects%2C%20luxurious%20premium%20aesthetic&width=1920&height=1080&seq=hero-banner-main&orientation=landscape"
          alt="欧美一区精选内容导航平台"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          欧美一区精选内容导航平台
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚海量优质欧美影视、音乐与文化内容，为您提供最全面的欧美一区资源导航与推荐服务，畅享欧美一区带来的高清视听体验与多元文化魅力。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/movies-tv"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            探索影视内容
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}